import { Typography } from "@mui/material";

interface Props {
  text: string;
}

const WhiteCardTitle = ({ text }: Props) => {
  return (
    <Typography sx={{ color: "white", fontSize: 17, fontWeight: "600" }}>
      {text}
    </Typography>
  );
};

export default WhiteCardTitle;
